// The stridy.com site footer, mirrored here so the dashboard closes with the
// same footer as the rest of the site (companion to siteNav.js, which mirrors
// the header). Content transcribed from the live Elementor footer template.
//
// Links are absolute stridy.com URLs — the dashboard is served from its own
// origin, so a site-relative href (the live template uses "/shop") would
// resolve against the dashboard instead.

export const FOOTER_BRAND_HREF = "https://stridy.com/";

// The white wordmark the footer uses (the header's is the dark one), at its
// 1024px-wide variant. Kept remote so it tracks whatever the site is serving.
export const FOOTER_LOGO_SRC =
  "https://stridy.com/wp-content/uploads/2022/02/IMG_2814-1-1024x211.png";
export const FOOTER_LOGO_SRCSET =
  "https://stridy.com/wp-content/uploads/2022/02/IMG_2814-1-600x123.png 600w, " +
  "https://stridy.com/wp-content/uploads/2022/02/IMG_2814-1-1024x211.png 1024w";

export const FOOTER_LINK_COLUMNS = [
  {
    heading: "About Stridy",
    links: [
      { label: "Stridy", href: "https://stridy.com/about-stridy/" },
      { label: "Stridy App", href: "https://stridy.com/about-stridy-app/" },
      { label: "Our Team", href: "https://stridy.com/our-team/" },
    ],
  },
  {
    heading: "Data",
    links: [
      {
        label: "Impact Dashboard",
        href: "https://stridy.com/community-impact-dashboard/",
      },
    ],
  },
  {
    heading: "Tools",
    links: [{ label: "Stridy Shop", href: "https://stridy.com/shop" }],
  },
  {
    heading: "Help & Information",
    links: [
      { label: "FAQs", href: "https://stridy.com/faq/" },
      { label: "Privacy Policy", href: "https://stridy.com/privacy/" },
      { label: "Terms of Use", href: "https://stridy.com/tos/" },
    ],
  },
];

// `icon` values are MDI brand glyphs (mdi-*), which resolve through the MDI
// stylesheet already loaded in public/index.html — the classic Material font we
// bundle has no brand icons. See docs/references/icons.md.
export const FOOTER_SOCIALS = [
  {
    label: "Instagram",
    icon: "mdi-instagram",
    href: "https://www.instagram.com/stridyapp/",
  },
  {
    label: "Facebook",
    icon: "mdi-facebook",
    href: "https://www.facebook.com/stridyapp",
  },
  {
    label: "Twitter",
    icon: "mdi-twitter",
    href: "https://twitter.com/stridyapp",
  },
  {
    label: "LinkedIn",
    icon: "mdi-linkedin",
    href: "https://www.linkedin.com/company/stridy",
  },
];

export const FOOTER_ADDRESS_LINES = [
  "8 Cross Street",
  "#20-01 Manulife Tower",
  "Singapore 048424",
];

export const FOOTER_EMAIL = "hello@stridy.com";

export const FOOTER_APP_BADGES = [
  {
    label: "Download Stridy on the App Store",
    href: "https://apps.apple.com/sg/app/stridy/id1526361298",
    src: "https://stridy.com/wp-content/uploads/2022/03/app-1-300x101.png",
    srcset:
      "https://stridy.com/wp-content/uploads/2022/03/app-1-300x101.png 300w, " +
      "https://stridy.com/wp-content/uploads/2022/03/app-1.png 498w",
  },
  {
    label: "Get Stridy on Google Play",
    href: "https://play.google.com/store/apps/details?id=com.stridy.stridy&hl=en_SG&gl=US",
    src: "https://stridy.com/wp-content/uploads/2022/03/google-1-1-300x89.png",
    srcset:
      "https://stridy.com/wp-content/uploads/2022/03/google-1-1-300x89.png 300w, " +
      "https://stridy.com/wp-content/uploads/2022/03/google-1-1.png 564w",
  },
];
